import { Divider } from 'shared/components/Base/Base'
import { Text } from 'shared/components/Text/Text'
import { UpcomingInvoice } from 'shared/models/subscription'
import { breakpoints } from 'shared/theme/breakpoints'
import { information, lightGray1, primaryBlack, royalBlue } from 'shared/theme/colors'
import styled from 'styled-components'

import { getBillingPeriodName } from '../../models/productSubscription'
import { FlexBox } from '../Base/FlexBox'
import { DiscountSmall } from '../Icons/Icon'
import { Pill } from '../Pill/Pill'

interface BillingTableProps {
  invoice: UpcomingInvoice
}

export function BillingTable({ invoice }: BillingTableProps) {
  const lineItems = invoice.lines
  const discount = invoice.discount
  const subTotal = invoice.subtotalNoFlatPriceDollarsFormatted || 0
  const subTotalWithFlatPrice = invoice.subTotalDollarsFormatted || 0
  const isFlexFlatPrice = subTotalWithFlatPrice !== subTotal
  const total = invoice.totalDollarsFormatted || 0

  return (
    <>
      {lineItems.map((item) => (
        <div key={item.product.name}>
          <BillingRow>
            <Text variant="paragraph2" fontColor={primaryBlack} fontWeight={600}>
              Seats
            </Text>
            <Text variant="paragraph2" fontColor={primaryBlack} fontWeight={600} align="right">
              {item.quantity}
            </Text>
          </BillingRow>
        </div>
      ))}

      <Divider />
      <BillingRow>
        <Text variant="paragraph2" fontColor={primaryBlack} fontWeight={600}>
          Total
        </Text>
        <FlexBox alignItems="center" justifyContent="flex-end">
          <Text
            variant="paragraph2"
            fontColor={primaryBlack}
            fontWeight={600}
            align="right"
            styles={isFlexFlatPrice || discount ? 'text-decoration: line-through' : undefined}
          >
            {subTotal}
          </Text>
          <Text variant="paragraph2" fontColor={lightGray1} fontWeight={600} align="right">
            /{getBillingPeriodName(lineItems[0].productPrice.billingPeriod)}
          </Text>
        </FlexBox>
      </BillingRow>

      {isFlexFlatPrice && (
        <BillingRow $styles="margin-top: 15px;">
          <Text variant="paragraph2" fontColor={primaryBlack} fontWeight={600}>
            <Pill background={information} color={royalBlue}>
              <FlexBox alignItems="center" gap="3px">
                <img src={DiscountSmall} alt="" />
                <span>Discount applied</span>
              </FlexBox>
            </Pill>
          </Text>
          <FlexBox alignItems="center" justifyContent="flex-end">
            <Text
              variant="paragraph2"
              as="span"
              fontColor={primaryBlack}
              fontWeight={600}
              align="right"
              styles={discount ? 'text-decoration: line-through' : undefined}
            >
              {subTotalWithFlatPrice}
            </Text>
            <Text variant="paragraph2" fontColor={lightGray1} fontWeight={600} align="right">
              /{getBillingPeriodName(lineItems[0].productPrice.billingPeriod)}
            </Text>
          </FlexBox>
        </BillingRow>
      )}

      {discount ? (
        <BillingRow $styles="margin-top: 15px;">
          <Text variant="paragraph2" fontColor={primaryBlack} fontWeight={600}>
            <Pill background={information} color={royalBlue}>
              <FlexBox alignItems="center" gap="3px">
                <img src={DiscountSmall} alt="" />
                <span>{discount.description}</span>
              </FlexBox>
            </Pill>
          </Text>
          <FlexBox alignItems="center" justifyContent="flex-end">
            <Text variant="paragraph2" fontColor={primaryBlack} fontWeight={600} align="right">
              {total}
            </Text>
            <Text variant="paragraph2" fontColor={lightGray1} fontWeight={600} align="right">
              /{getBillingPeriodName(lineItems[0].productPrice.billingPeriod)}
            </Text>
          </FlexBox>
        </BillingRow>
      ) : null}
    </>
  )
}

const BillingRow = styled.div<{ $styles?: string }>`
  margin-top: 20px;
  margin-bottom: 15px;
  display: grid;
  grid-template-columns: 250px 1fr;
  gap: 10px;

  @media ${breakpoints.xs} {
    grid-template-columns: 1fr 1fr;
    width: 100%;
  }

  ${(p) => p.$styles};
`
